import { SPLASH_LOGO_SRC } from '@app/core/splash/splash-screen';
import '@app/core/splash/splash-screen.css';
import { Box } from '@mui/material';

import { LoginButton } from './LoginButton';
import { LoginErrorAlert } from './LoginErrorAlert';

/**
 * Branded login surface shown when Auth0 / app-init failed and the user
 * was sent back with a login_error query param. Visual language matches SplashLoader.
 */
export function LoginErrorScreen() {
  return (
    <div className="mi-splash">
      <div className="mi-splash__wash" aria-hidden />
      <div className="mi-splash__content mi-splash__content--enter mi-splash__content--error">
        <img className="mi-splash__logo" src={SPLASH_LOGO_SRC} alt="MediaInbox logo" />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1.5,
            width: '100%',
            mt: 0.5,
          }}
        >
          <LoginErrorAlert />
          <Box sx={{ mt: 0.5 }}>
            <LoginButton />
          </Box>
        </Box>
      </div>
    </div>
  );
}
